import styled from 'styled-components';

import { visuallyHiddenCss } from 'components/VisuallyHidden';
import { colors, cssBreakpoints } from 'theme/theme';

export const CmsTileModalCloseButtonStyled = styled.button`
  height: 41px;
  color: ${colors.lightContentGrey};
  background-color: transparent;
  border-radius: 0;
  display: flex;
  align-items: center;

  &:hover:not(:disabled) {
    color: ${colors.brandBlue};
  }
`;

export const CmsTileModalCloseButtonText = styled.span`
  height: 18px;
  margin-right: 8px;
  display: block;

  @media all and (max-width: ${cssBreakpoints.xsDown}) {
    /* block-no-empty */
    ${visuallyHiddenCss}
  }
`;
